import { Api } from "api";

export const getCompanies = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/companies/?hash_pw=${hash}`);
  return res.data;
};

export const addCompany = async (company: string, location_id: number, bin: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/company/?hash_pw=${hash}&company=${company}&location_id=${location_id}&bin=${bin}`);
  return res.data;
};

export const updateCompany = async (
  companyId: number,
  new_company: string,
  location_id: number,
  bin: string,
  new_status: boolean
) => {
  const hash = localStorage.getItem("hash");
  const name = new_company !== undefined ? `&new_company=${new_company}` : "";
  const status = new_status !== undefined ? `&status=${new_status}` : "";
  const locId = location_id !== undefined ? `&location_id=${location_id}` : "";
  const binNum = bin !== undefined ? `&bin=${bin}` : "";
  const url = `/company/?hash_pw=${hash}&company_id=${companyId}${name}${locId}${binNum}${status}`;
  const res = await Api.put(url);
  return res.data;
};
